/** @format */

import * as R from 'ramda';

import {YalperPlatform} from 'graphql/generated/types';

// Elama uses same account and campaign links - it's the best we can do
const YANDEX_DIRECT_URL = 'https://direct.yandex.ru/dna/grid';
const GOOGLE_ADS_URL = 'https://ads.google.com/aw';

export const CAMPAIGNS_SECTION = 'CAMPAIGNS';
export const AD_GROUPS_SECTION = 'AD_GROUPS';
export const ADS_SECTION = 'ADS';
export const SITELINKS_SECTION = 'SITELINK';
export const KEYWORDS_SECTION = 'KEYWORDS';

export const accountLink = (platform: YalperPlatform, accountId: string) => {
  if (platform === 'YANDEX') {
    // Opens account even if user is not logged in yet
    return `${YANDEX_DIRECT_URL}/campaigns?ulogin=${accountId}`;
  }

  if (platform === 'GOOGLE') {
    // Opens not managed account
    // Open manager account for managed account
    return `${GOOGLE_ADS_URL}/overview?__e=${accountId}`;
  }

  return null;
};

export const campaignLink = (platform: YalperPlatform, accountId: string, campaignId: string) => {
  if (platform === 'YANDEX') {
    const query = `campaigns-ids=${campaignId}&ulogin=${accountId}`;
    // Opens campaign only when user is already logged in
    return `${YANDEX_DIRECT_URL}/groups?${query}`;
  }

  if (platform === 'GOOGLE') {
    // Opens campaign of not managed account
    // Opens manager account for campaign of managed account
    return `${GOOGLE_ADS_URL}/express/dashboard?campaignId=${campaignId}`;
  }

  return null;
};

export const locationSections = (sensorName: string) => {
  const mapping: Record<string, string[]> = {
    'as-404': [ADS_SECTION],
    'as-ad-double': [ADS_SECTION],
    'as-ad-has-image': [ADS_SECTION],
    'as-ad-header': [ADS_SECTION],
    'as-ad-high-bounce-rate': [ADS_SECTION],
    'as-ad-lim-links': [ADS_SECTION],
    'as-ad-lim-title': [ADS_SECTION],
    'as-ad-second-title': [ADS_SECTION],
    'as-ad-title-copy': [ADS_SECTION],
    'as-ad-title-nokey': [ADS_SECTION],
    'as-ad-vcard': [ADS_SECTION],
    'as-bad-keys': [KEYWORDS_SECTION],
    'as-clicks-dropped': [ADS_SECTION],
    'as-conversion-dropped': [ADS_SECTION],
    'as-fade': [ADS_SECTION],
    'as-geo': [AD_GROUPS_SECTION],
    'as-geo-card': [ADS_SECTION],
    'as-geo-domain': [ADS_SECTION, SITELINKS_SECTION],
    'as-geo-name-mismatch': [AD_GROUPS_SECTION],
    'as-geo-text': [ADS_SECTION, SITELINKS_SECTION],
    'as-geo-view-link': [ADS_SECTION],
    'as-high-imp-ratio': [CAMPAIGNS_SECTION],
    'as-impression-dropped': [ADS_SECTION],
    'as-key-high-bounce-rate': [KEYWORDS_SECTION],
    'as-low-imp': [AD_GROUPS_SECTION],
    'as-lowbid': [KEYWORDS_SECTION],
    'as-mod': [ADS_SECTION],
    'as-sale': [ADS_SECTION],
    'as-spend-key': [KEYWORDS_SECTION],
    'as-spent': [CAMPAIGNS_SECTION],
    'as-typo': [ADS_SECTION],
    'as-url-struct': [CAMPAIGNS_SECTION],
    'as-use-utm-adwords': [ADS_SECTION],
    'as-utm': [CAMPAIGNS_SECTION],
    'as-utm-in-link': [CAMPAIGNS_SECTION],
    'as-utm-param-double': [ADS_SECTION],
    'as-utm-presence': [CAMPAIGNS_SECTION],
    'as-utm-settings': [CAMPAIGNS_SECTION],
  };

  return mapping[sensorName] || [];
};

export const reportLink = (
  userUUID: string,
  uuid: string,
  lastCheckCollectDate: string,
  sensors: string,
  platforms: string,
  format: string,
  lang: string,
) => {
  return R.join('')([
    `${import.meta.env.VITE_YALPER_URI}/as-api`,
    `/user/${userUUID}`,
    `/client/${uuid}`,
    `/report/${lastCheckCollectDate}`,
    `?sensors=${sensors}&platforms=${platforms}&format=${format}&lang=${lang}&source=web_app`,
  ]);
};
